if (!customElements.get('smileat-podcast-component')) {
    class SmileatPodcast extends HTMLElement {
        connectedCallback() {
            this.initVideoPopup();
            this.initSharePopup();
            // Wait for DOM to be fully ready
            setTimeout(() => {
                this.checkUrlParams();
            }, 100);
        }

        initVideoPopup() {
            this.episodeCards = this.querySelectorAll('.smileat-podcast-card--episode');
            const sectionId = this.dataset.sectionId;
            this.modal = document.querySelector(`#PodcastVideoModal-${sectionId}`);
            
            if (!this.modal) return;

            this.iframe = this.modal.querySelector('.smileat-video-modal__iframe');
            const closeBtn = this.modal.querySelector('.smileat-video-modal__close');
            const overlay = this.modal.querySelector('.smileat-video-modal__overlay');
            this.titleEl = this.modal.querySelector('.smileat-video-modal__title');
            this.descriptionEl = this.modal.querySelector('.smileat-video-modal__description');
            this.youtubeBtn = this.modal.querySelector('.smileat-video-modal__social-link--youtube');
            this.spotifyBtn = this.modal.querySelector('.smileat-video-modal__social-link--spotify');
            this.shareBtn = this.modal.querySelector('.smileat-video-modal__social-link--share');

            this.episodeCards.forEach(card => {
                card.addEventListener('click', (e) => {
                    // Prevent trigger if clicking on social links
                    if (e.target.closest('.smileat-podcast-card__socials')) return;
                    this.openVideoModal(card);
                });
            });

            const closeModal = () => {
                this.modal.setAttribute('aria-hidden', 'true');
                document.body.style.overflow = '';
                if (this.iframe) this.iframe.src = '';
            };

            if (closeBtn) closeBtn.addEventListener('click', closeModal);
            if (overlay) overlay.addEventListener('click', closeModal);
            this.modal.addEventListener('click', (e) => {
                const container = this.modal.querySelector('.smileat-video-modal__container');
                if (!container) return;
                if (!container.contains(e.target)) {
                    closeModal();
                }
            });

            window.addEventListener('keydown', (e) => {
                if (e.key === 'Escape' && this.modal.getAttribute('aria-hidden') === 'false') {
                    closeModal();
                }
            });

            if (this.shareBtn) {
                this.shareBtn.addEventListener('click', async (e) => {
                   e.preventDefault();
                   const shareUrl = this.shareBtn.dataset.url;
                   if (!shareUrl) return;
                   
                   try {
                       await navigator.clipboard.writeText(shareUrl);
                       const originalText = this.shareBtn.innerHTML;
                       // No easy way to show text on icon without tooltip, but let's just do it
                       // Actually, just alert or generic feedback is fine for now
                   } catch (err) {}
                });
            }
        }

        openVideoModal(card) {
            if (!card || !this.modal) return;

            const videoLink = card.dataset.videoLink;
            if (videoLink) {
                window.open(videoLink, '_blank');
                return;
            }

            const videoUrl = card.dataset.videoUrl;
            if (!videoUrl) return;

            const cardTitle = card.querySelector('.smileat-podcast-card__episode-title')?.innerText || card.querySelector('.smileat-podcast-card__episode-title')?.innerHTML;
            const description = card.dataset.videoDescription;
            const youtubeLink = card.dataset.youtubeLink;
            const spotifyLink = card.dataset.spotifyLink;
            const shareUrl = card.dataset.shareUrl;

            // Open modal
            this.modal.setAttribute('aria-hidden', 'false');
            document.body.style.overflow = 'hidden';

            if (this.titleEl) {
                this.titleEl.innerHTML = cardTitle || '';
                this.titleEl.style.display = cardTitle ? 'block' : 'none';
            }

            if (this.descriptionEl) {
                this.descriptionEl.innerHTML = description || '';
                this.descriptionEl.style.display = description ? 'block' : 'none';
            }

            if (this.youtubeBtn) {
                this.youtubeBtn.href = youtubeLink || '#';
                this.youtubeBtn.style.display = youtubeLink ? 'flex' : 'none';
            }

            if (this.spotifyBtn) {
                this.spotifyBtn.href = spotifyLink || '#';
                this.spotifyBtn.style.display = spotifyLink ? 'flex' : 'none';
            }

            if (this.shareBtn) {
                this.shareBtn.dataset.url = shareUrl || '';
            }

            // Load video in iframe
            if (videoUrl && this.iframe) {
                this.iframe.src = videoUrl;
            }
        }

        checkUrlParams() {
            const urlParams = new URLSearchParams(window.location.search);
            const videoId = urlParams.get('v');
            if (videoId) {
                const targetCard = Array.from(this.episodeCards).find(card => card.dataset.videoId === videoId);
                if (targetCard) {
                    this.openVideoModal(targetCard);
                }
            }
        }

        initSharePopup() {
            const episodeCards = this.querySelectorAll('.smileat-podcast-card--episode');
            if (!episodeCards.length) return;

            let activePopover = null;

            const hidePopover = (popover) => {
                if (!popover) return;
                popover.hidden = true;
                popover.classList.remove('is-open');
            };

            const hideAllPopovers = () => {
                this.querySelectorAll('[data-share-popover].is-open').forEach((popover) => {
                    hidePopover(popover);
                });
                activePopover = null;
            };

            const updateShareLinks = (popover, shareUrl) => {
                const encodedUrl = encodeURIComponent(shareUrl);
                const shareMap = {
                    whatsapp: `https://api.whatsapp.com/send?text=${encodedUrl}`,
                    facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`,
                    x: `https://twitter.com/intent/tweet?url=${encodedUrl}`,
                    email: `mailto:?body=${encodedUrl}`,
                    linkedin: `https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`
                };

                Object.entries(shareMap).forEach(([target, href]) => {
                    const anchor = popover.querySelector(`[data-share-target="${target}"]`);
                    if (!anchor) return;
                    const customLink = anchor.dataset.shareCustomLink;
                    anchor.href = customLink && customLink.trim() !== '' ? customLink : href;
                });

                const urlInput = popover.querySelector('[data-share-input]');
                if (urlInput) urlInput.value = shareUrl;
            };

            episodeCards.forEach((card) => {
                const shareBtn = card.querySelector('.smileat-podcast-card__social-link--share');
                const popover = card.querySelector('[data-share-popover]');
                if (!shareBtn || !popover) return;

                const shareUrl = card.dataset.shareUrl || window.location.href;
                updateShareLinks(popover, shareUrl);

                shareBtn.addEventListener('click', (event) => {
                    event.preventDefault();
                    event.stopPropagation();

                    if (activePopover && activePopover !== popover) {
                        hidePopover(activePopover);
                    }

                    const isOpen = popover.classList.contains('is-open');
                    if (isOpen) {
                        hidePopover(popover);
                        activePopover = null;
                        return;
                    }

                    popover.hidden = false;
                    popover.classList.add('is-open');
                    activePopover = popover;
                });

                const closeBtn = popover.querySelector('[data-share-close]');
                if (closeBtn) {
                    closeBtn.addEventListener('click', (event) => {
                        event.preventDefault();
                        event.stopPropagation();
                        hidePopover(popover);
                        if (activePopover === popover) activePopover = null;
                    });
                }

                const copyBtn = popover.querySelector('[data-share-copy]');
                const urlInput = popover.querySelector('[data-share-input]');
                if (copyBtn && urlInput) {
                    copyBtn.addEventListener('click', async (event) => {
                        event.preventDefault();
                        event.stopPropagation();
                        try {
                            await navigator.clipboard.writeText(urlInput.value);
                            copyBtn.textContent = 'Copiado';
                            setTimeout(() => {
                                copyBtn.textContent = 'Copiar';
                            }, 1800);
                        } catch (error) {
                            urlInput.focus();
                            urlInput.select();
                        }
                    });
                }
            });

            document.addEventListener('click', (event) => {
                const clickedShareUI = event.target.closest('[data-share-popover], .smileat-podcast-card__social-link--share');
                if (!clickedShareUI) hideAllPopovers();
            });

            window.addEventListener('keydown', (event) => {
                if (event.key === 'Escape') hideAllPopovers();
            });
        }
    }

    customElements.define('smileat-podcast-component', SmileatPodcast);
}
